import { createGlobalState } from "react-hooks-global-state";

const initialState: {
  claimerMintToggleStatus: {
    wallet: boolean;
    accounts: boolean;
    validator: boolean;
    bridge: boolean;
    recover_tx: boolean;
  };
} = {
  claimerMintToggleStatus: {
    wallet: false,
    accounts: false,
    validator: false,
    bridge: false,
    recover_tx: false,
  },
};

const { useGlobalState } = createGlobalState(initialState);

export default useGlobalState;
